import DashOrEllipText from './DashOrEllipText';

export default DashOrEllipText;
